import { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import results from './Depoimentos.images';
import {
  activeImage,
  arrow,
  container,
  image,
  section,
  title,
  inactiveImage,
  leftArrow,
  rightArrow,
  sliderContainer,
  button,
} from './Depoimentos.styles';
import { IoChatboxEllipsesOutline } from 'react-icons/io5';
import { handleOpenLink } from '../../utils/common';

export default function Depoimentos() {
  const [isMobile, setIsMobile] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  return (
    <section className={section} id='avaliacoes'>
      <p className={title}>Avaliações</p>

      <div className={container}>
        <div ref={prevRef} className={`${arrow} ${leftArrow}`}>
          <IoIosArrowBack size={isMobile ? 30 : 40} className={'text-title'} />
        </div>

        <div ref={nextRef} className={`${arrow} ${rightArrow}`}>
          <IoIosArrowForward
            size={isMobile ? 30 : 40}
            className={'text-title'}
          />
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          spaceBetween={30}
          slidesPerView={isMobile ? 1 : 3}
          centeredSlides
          speed={800}
          className={sliderContainer}
          loop
        >
          {results.map((src, i) => (
            <SwiperSlide key={i} className='transition-all duration-300'>
              {({ isActive }) => (
                <img
                  src={src}
                  alt={`Resultado ${i + 1}`}
                  draggable={false}
                  onContextMenu={(e) => e.preventDefault()}
                  className={`${image} ${
                    isActive ? activeImage : inactiveImage
                  }`}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <button
        onClick={() =>
          handleOpenLink(
            'https://g.page/r/Cblh_7GdNXGxEBM/review',
            'avaliar_click',
            'Realizar Avaliação',
            window.location.pathname
          )
        }
        className={button}
      >
        <IoChatboxEllipsesOutline />
        Avaliar
      </button>
    </section>
  );
}
